export default "__VITE_ASSET__BrzILAx8__"